import { MouseEventHandler, ReactNode } from 'react';
import styled from 'styled-components';

import { toRgbString } from 'packages/kakapo-ui-kit/helpers/HexColor';

interface IProps {
	onClick: MouseEventHandler<HTMLElement>;
	children: ReactNode;
	isLight?: boolean;
	color: string;
	hoverColor?: string;
	shouldOverrideIconColor?: boolean;
	size: number;
}

interface ElementProps {
	$size: number;
	$isLight?: boolean;
	$shouldOverrideIconColor?: boolean;
	$color: string;
	$hoverColor?: string;
}

const CircleButtonContainer = styled.button<ElementProps>`
	height: ${(props) => props.$size}px;
	width: ${(props) => props.$size}px;
	border-radius: ${(props) => props.$size / 2}px;
	border: 0;
	background-color: ${(props) =>
		props.$isLight
			? `rgba(${toRgbString(props.theme.colors[props.$color])}, 0.3)`
			: props.theme.colors[props.$color]};
	align-items: center;
	justify-content: center;
	display: flex;
	padding: 0px;

	${(props) =>
		props.$shouldOverrideIconColor
			? `svg g, svg path {
		fill: ${props.$isLight ? props.theme.colors[props.$color] : props.theme.colors.white};
	}
	color: ${props.$isLight ? props.theme.colors[props.$color] : props.theme.colors.white};
	:hover {
		svg g, svg path {
			fill: ${props.$isLight ? props.theme.colors.white : props.theme.colors[props.$color]};
		}
		color: ${props.$isLight ? props.theme.colors.white : props.theme.colors[props.$color]};
	}
	`
			: ''}

	:hover {
		cursor: pointer;
		background-color: ${(props) =>
			props.$isLight
				? props.theme.colors[props.$color]
				: props.$hoverColor
				? props.theme.colors[props.$hoverColor]
				: `rgba(${toRgbString(props.theme.colors[props.$color])}, 0.3)`};
	}
`;

export default function CircleButton({
	onClick,
	size,
	isLight,
	children,
	shouldOverrideIconColor,
	color,
	hoverColor,
}: IProps) {
	return (
		<CircleButtonContainer
			$isLight={isLight}
			$size={size}
			$shouldOverrideIconColor={shouldOverrideIconColor}
			$color={color}
			$hoverColor={hoverColor}
			type="button"
			onClick={onClick}
		>
			{children}
		</CircleButtonContainer>
	);
}
